import { aboutContent } from '@/mocks/homeData';

const aboutImage = 'https://readdy.ai/api/search-image?query=Cozy%20reading%20space%20with%20manga%20comic%20books%20on%20wooden%20shelves%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%2C%20comfortable%20armchair%20with%20soft%20cushion%2C%20digital%20tablet%20displaying%20colorful%20comic%20pages%2C%20warm%20cream%20and%20wood%20tone%20interior%2C%20clean%20minimalist%20aesthetic%2C%20inviting%20atmosphere&width=1000&height=700&seq=about-visual&orientation=landscape';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 lg:order-2">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{aboutContent.title}</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{aboutContent.desc1}</p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{aboutContent.desc2}</p>
            <div className="mt-6 flex flex-wrap gap-5">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className="ri-book-open-line text-lg"></i>
                </div>
                <div>
                  <div className="text-lg font-heading font-bold text-foreground-900">17600+</div>
                  <div className="text-xs text-foreground-500">收录漫画</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-user-heart-line text-lg"></i>
                </div>
                <div>
                  <div className="text-lg font-heading font-bold text-foreground-900">860万+</div>
                  <div className="text-xs text-foreground-500">活跃读者</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-200 text-secondary-700">
                  <i className="ri-calendar-check-line text-lg"></i>
                </div>
                <div>
                  <div className="text-lg font-heading font-bold text-foreground-900">2018年</div>
                  <div className="text-xs text-foreground-500">成立至今</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 lg:order-1">
            <div className="rounded-2xl overflow-hidden border border-background-200/60">
              <img
                src={aboutImage}
                alt="关于星星动漫网 - 温馨的漫画阅读空间"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}